module.exports = __webpack_public_path__ + "img/about_cart02.ea6beee5.jpg";